import { Stack } from "@mui/material";
import type { PropsWithChildren } from "react";

type Props = {
	align: "flex-start" | "flex-end";
};

export const MyPlannNavigationHeaderActionSlot = ({
	align,
	children,
}: PropsWithChildren<Props>) => (
	<Stack
		direction="row"
		alignItems="center"
		justifyContent={align}
		gap={1.2}
		minWidth={40}
		height={40}
		flexShrink={0}
	>
		{children}
	</Stack>
);
